import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { getColorClasses } from '@/lib/design-system';

interface MarketingCardProps {
  children: React.ReactNode;
  variant?: 'default' | 'featured' | 'transparent' | 'success' | 'warning';
  className?: string;
  hover?: boolean;
  gradient?: boolean;
}

export const MarketingCard: React.FC<MarketingCardProps> = ({
  children,
  variant = 'default',
  className,
  hover = true,
  gradient = false,
}) => {
  const baseClasses = cn(
    'rounded-lg transition-all duration-300',
    hover && 'hover:shadow-lg hover:-translate-y-1'
  );

  const variantClasses = {
    default: cn(getColorClasses.background.pure(), 'shadow-md border-0'),
    featured: cn(
      getColorClasses.background.pure(),
      'shadow-xl',
      getColorClasses.border.primary(),
      'border border-opacity-10',
      gradient && 'bg-gradient-to-br from-white to-brand-primary/5'
    ),
    transparent: cn('bg-white/80 backdrop-blur-sm shadow-2xl border-0'),
    success: cn(
      getColorClasses.background.pure(),
      'shadow-lg',
      getColorClasses.border.success(),
      'border border-opacity-20'
    ),
    warning: cn(
      getColorClasses.background.pure(),
      'shadow-lg',
      getColorClasses.border.warning(),
      'border border-opacity-20'
    ),
  };

  return (
    <Card className={cn(baseClasses, variantClasses[variant], className)}>
      <CardContent className='p-6'>{children}</CardContent>
    </Card>
  );
};
